import Vue from 'vue';
import App from './App.vue';
import store from './store/store';
import './assets/app.scss';
import VTooltip from 'v-tooltip'

Vue.use(VTooltip, {
  defaultTrigger: window.innerWidth > 768 ? 'hover focus click' : 'click'
})

Vue.filter('intToDecimalPrice', int => '$' + (int / 100).toFixed(2));

Vue.filter('moneySaleFormat', (price) => {
  if (price) {
    return `$${price}`;
  }
  return '';
});

Vue.filter('moneyFormat', (product) => {
  if (product.variants) {
    let variantPrice = product.variants.find(x => x.price != 0);
    if (variantPrice)
      return `$${variantPrice.price}`;
    else 
      return `$0`
  }
  return '';
});

Vue.filter('getProductImage', product => (product.images.length > 0) ? product.images[0].src : '');

Vue.filter('getProductLastImage', product => (product.images.length > 0) ? product.images[product.images.length - 1].src : '');


/* eslint-disable no-unused-vars */
const SwagApp = new Vue({
  el: '#Swag',
  data: {
  },
  store,
  created() {
    this.$store.dispatch('getProducts');
  },
  render: h => h(App),
});
